export const opportunityTagLine = {
	Scholarships: `Empowering Dreams Through Education : Unlocking Future Possibilities.`,
	ITJobs: `Building Futures Together : Your Gateway to Professional Success.`,
	CodingContests: `Where Innovation Meets Competition : Join Our Coding Challenges.`,
};
